import './card-reviews.scss';

export default () => {
	$( '.js-reviews-btn' ).click( function ( e ) {
		e.preventDefault();
		$( 'dots' ).toggle( 0 );
		$( '.js-reviews-extra' ).toggle( 0 );
	} );
};
